import React from "react";

const YOU_BADGE_CLASS =
  "inline-flex items-center rounded-md bg-indigo-100 px-1.5 py-0.5 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10";

export default function TeamMemberYouBadge() {
  return <span className={YOU_BADGE_CLASS}>You</span>;
}
